export default __webpack_public_path__ + "static/media/2.836cdabe.jpeg";